<template lang="pug">
div
    Card.a8-page-description-card
            Row(:gutter="16" type="flex" justify="space-between")
                Col(span="12")
                    h2 {{ $t('behaviorAnalyze.pageTitleText') }}
                    //- p {{ $t('behaviorAnalyze.pageSubtitleText') }}
                //- Col(span="12")
                //-     RadioGroup(v-model="selectedRadio")
                //-         List(size="small" border)
                //-             ListItem(v-for="item in radioList" :key="item.key")
                //-                 ListItemMeta
                //-                     template(slot="avatar")
                //-                         Radio(:label="item.key")
                //-                             span
                //-                     template(slot="title")
                //-                         span {{item.title}}
                //-                     template(slot="description")
                //-                         span {{item.description}}
    template(v-if="selectedRadio === 'settings'")
        IntelligentProtectionSettings(:searchView="searchView")
    template(v-if="selectedRadio === 'events'")
        Tabs(
            :value="behaviorType"
            @on-click="handleBehaviorTypeChange"
            :key="$i18n.locale"
        )
            TabPane(:label="$t('behaviorAnalyze.all')" name="*")
            TabPane(:label="$t('behaviorAnalyze.sensitivePaths')" name="db0")
            TabPane(:label="$t('behaviorAnalyze.specialBehaviors')" name="db1")

        // ==== 數字卡片：分類行為統計 ====
        Row
            Col.ip-chart-col(:xs="24" :sm="24" :md="6" :lg="6")
                // ---- 異常操作使用者的請求次數 ----
                Card.number-card(dis-hover)
                    h1.number-value {{ behaviorClassificationStats.db0Count }}
                    p.number-label {{ $t("behaviorAnalyze.sensitivePathsRequests") }}
                    Spin.percent(v-if="isUsageLoading")
                    span.percent(v-else) {{ db0RequestPercent }}
            Col.ip-chart-col(:xs="24" :sm="24" :md="6" :lg="6")
                // ---- 異常操作使用者 ----
                Card.number-card(dis-hover)
                    h1.number-value {{ behaviorUserStats.db0UserCount }}
                    p.number-label {{ $t("behaviorAnalyze.sensitivePathsUsers") }}
                    Spin.percent(v-if="isUsageLoading")
                    span.percent(v-else) {{ db0UserPercent }}
                    Button.protect-btn(size="small" disabled) {{ $t("behaviorAnalyze.enableProtection") }}
                    JsonPoptip.eye-btn(
                        :title="$t('behaviorAnalyze.sensitivePathsUsersIpList')"
                        :jsonData="behaviorUserStats.db0IpList.join('\\n')"
                        buttonIcon="md-eye"
                        buttonText=""
                        :showHint="true"
                        :hintText="$t('behaviorAnalyze.ipListHint')"
                    )
            Col.ip-chart-col(:xs="24" :sm="24" :md="6" :lg="6")
                // ---- 異常行為使用者的請求次數 ----
                Card.number-card(dis-hover)
                    h1.number-value {{ behaviorClassificationStats.db1Count }}
                    p.number-label {{ $t("behaviorAnalyze.specialBehaviorRequests") }}
                    Spin.percent(v-if="isUsageLoading")
                    span.percent(v-else) {{ db1RequestPercent }}
            Col.ip-chart-col(:xs="24" :sm="24" :md="6" :lg="6")
                // ---- 異常行為使用者 ----
                Card.number-card(dis-hover)
                    h1.number-value {{ behaviorUserStats.db1UserCount }}
                    p.number-label {{ $t("behaviorAnalyze.specialBehaviorUsers") }}
                    Spin.percent(v-if="isUsageLoading")
                    span.percent(v-else) {{ db1UserPercent }}
                    Button.protect-btn(size="small" disabled) {{ $t("behaviorAnalyze.enableProtection") }}
                    JsonPoptip.eye-btn(
                        :title="$t('behaviorAnalyze.specialBehaviorUsersIpList')"
                        :jsonData="behaviorUserStats.db1IpList.join('\\n')"
                        buttonIcon="md-eye"
                        buttonText=""
                        :showHint="true"
                        :hintText="$t('behaviorAnalyze.ipListHint')"
                    )

        // ===== 表格 =====
        TableWithColumnDrawer(
            :column-options="columnOptions"
            :data="data"
            :total="tableDataTotal"
            :loading="isLoading"
            :page-size="pageSize"
            :page-current="pageCurrent"
            :page-size-opts="[10, 20, 40, 100]"
            :total-text="$t('rcmtable.totalDataCountText')"
            :page-sizer-text="$t('rcmtable.page')"
            @change-page="changePage"
            @change-page-size="changePageSize"
            @row-select-change="checkboxOnChange"
        )

        // ===== 提示文字 =====
        Row.ip-empty-hint
            Col(:span="24")
                Divider(v-if="!selectedIp && !ipTrafficChartData.length" style="color: red")
                    | {{ $t("behaviorAnalyze.pleaseSelectOneIPRecordFromTheTableAbove") }}
                Divider(v-else style="color: red")
                    | {{$t("behaviorAnalyze.currentAnalyzedIp")}} {{ this.selectedIp }}

        // ===== 上排：圓餅 + 儀表板 + 請求總數 + 資料使用量 =====
        Row.ip-chart-row(type="flex" :gutter="16")
            // 狀態碼分佈
            Col.ip-chart-col(:xs="24" :sm="24" :md="8" :lg="8")
                Card.ip-chart-card(dis-hover)
                    h4.ip-chart-title {{ $t('behaviorAnalyze.originStatusCodeDistribution') }}
                    div.ip-chart-body
                        IpTrafficStatusPieChart(
                            v-if="ipStatusStats.length"
                            :status-stats="ipStatusStats"
                        )
                        p.ip-chart-empty(v-else) {{ $t('main.tableNoDataText') }}

            // 源站命中率
            Col.ip-chart-col(:xs="24" :sm="24" :md="8" :lg="8")
                Card.ip-chart-card(dis-hover)
                    h4.ip-chart-title {{ $t('behaviorAnalyze.originFetchRatio') }}
                    div.ip-chart-body
                        IpOriginHitGaugeChart(
                            v-if="selectedIp && ipTrafficChartData.length"
                            :origin-stats="originStats"
                        )
                        p.ip-chart-empty(v-else) {{ $t('main.tableNoDataText') }}
            // ==== 數字卡片：請求總數 + 資料使用量 ====
            Col.ip-chart-col(:xs="24" :sm="24" :md="8" :lg="8")
                // ---- 請求總數 ----
                Card.number-card(dis-hover)
                    h1.number-value {{ formattedTotalCount }}
                    p.number-label {{ $t('behaviorAnalyze.totalRequests') }}
                // ---- 資料使用量 ----
                Card.number-card(dis-hover)
                    h1.number-value {{ formattedTotalBytes }}
                    p.number-label {{ $t('behaviorAnalyze.dataUsage') }}

        // ===== 長條圖 =====
        Row
            Col(:span="24")
                Card.ip-traffic-bar-card(dis-hover)
                    h4.ip-chart-title {{ $t('behaviorAnalyze.dailyRequestTrend') }}
                    div.ip-traffic-bar-body
                        IpTrafficBarChart(
                            v-if="ipTrafficChartData.length"
                            :chart-data="ipTrafficChartData"
                        )
                        p.ip-chart-empty(v-else) {{ $t('main.tableNoDataText') }}
</template>

<script>
import IntelligentProtectionSettings from "@/view/IntelligentProtectionSettings/Page.vue";
import { getBehaviorAnalyzeDataList, getIpTrafficByCusRealAddr, getAccessLogUsage } from "@/api/monitor.js";
import TableWithColumnDrawer from "@/components/Table/TableWithColumnDrawer.vue";
import IpTrafficStatusPieChart from "@/components/Chart/IpTrafficStatusPieChart.vue";
import IpOriginHitGaugeChart from "@/components/Chart/IpOriginHitGaugeChart.vue";
import IpTrafficBarChart from "@/components/Chart/IpTrafficBarChart.vue";
import JsonPoptip from "@/components/JsonPoptip";
import { getEsData } from "@/api/esdata";

export default {
    name: "BehaviorAnalyze",
    components: {
        IntelligentProtectionSettings,
        TableWithColumnDrawer,
        IpTrafficBarChart,
        IpTrafficStatusPieChart,
        IpOriginHitGaugeChart,
        JsonPoptip
    },
    data() {
        return {
            // 是 wafEventFieldKeys 要顯示的的 key
            wafEventFieldKeys: [
                "req_id",
                "server_name",
                "timestamp",
                "group",
                "servicegroup",
                "host",
                "tb_action",
                "tb_rule",
                "tb_reason",
                "cus_realy_addr",
                "country",
                "request_method",
                "status",
                "scheme",
                "server_port",
                "uri",
                "args",
                "request_url",
                "req_headers",
                "request_time",
                "upstream_response_time",
                "upstream_status",
                "server_protocol",
                "proxyType",
                "isp",
                "originHostResolve",
                "raw_uri",
                "raw_args",
                "ssl_ja3",
                "ssl_ja3_hash",
                "upstream_cache_status",
                "bytes_sent"
            ],
            // 欄位定義
            columnOptions: [
                {
                    key: "",
                    title: this.$t("wafevent.viewWafEvent"),
                    checked: true,
                    width: 50,
                    render: (h, { row }) => {
                        if (row._loading === undefined) this.$set(row, "_loading", false);
                        if (row._detail === undefined) this.$set(row, "_detail", null);

                        return h("div", [
                            h(JsonPoptip, {
                                props: {
                                    title: `Search Waf Event ${row.rid} `,
                                    jsonData: row._detail,
                                    displayType: "keyValue",
                                    i18nPrefix: "wafevent",
                                    buttonIcon: "md-eye",
                                    buttonText: "",
                                    width: "60%"
                                },
                                nativeOn: {
                                    click: async e => {
                                        if (row._loading) return;
                                        row._loading = true;
                                        try {
                                            const detail = await this.fetchDetail(row.rid);

                                            // 過濾前（raw data）
                                            const raw =
                                                detail && detail.data && detail.data.mapData && detail.data.mapData[0];

                                            // 過濾後
                                            const filtered = raw
                                                ? this.filterByKeys(raw, this.wafEventFieldKeys)
                                                : null;

                                            // 存可顯示資料
                                            row._detail = filtered;
                                        } finally {
                                            row._loading = false;
                                        }
                                    }
                                }
                            })
                        ]);
                    }
                },
                {
                    key: "rid",
                    title: "ID",
                    checked: false,
                    width: 100
                },
                {
                    key: "ip",
                    title: "IP",
                    checked: true,
                    width: 120,
                    render: (h, params) => {
                        const { ip, rid } = params.row;
                        return h(
                            "div",
                            {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px"
                                }
                            },
                            [
                                h(
                                    "a",
                                    {
                                        style: {
                                            cursor: "pointer",
                                            textDecoration: "underline"
                                        },
                                        on: {
                                            click: () => this.goToWafEvents({ ip })
                                        }
                                    },
                                    ip
                                )
                            ]
                        );
                    }
                },
                {
                    key: "servername",
                    title: this.$t("behaviorAnalyze.servername"),
                    checked: true,
                    width: 150
                },
                {
                    key: "resource",
                    title: this.$t("behaviorAnalyze.originResource"),
                    checked: true,
                    width: 250
                },
                {
                    key: "upstream_http_status",
                    title: this.$t("behaviorAnalyze.originStatusCode"),
                    checked: true,
                    width: 100
                },
                {
                    key: "timestamp",
                    title: this.$t("behaviorAnalyze.eventTime"),
                    checked: true,
                    sortable: "true",
                    isTime: true,
                    width: 200
                },
                {
                    key: "anomaly_score",
                    title: this.$t("behaviorAnalyze.detectionScore"),
                    checked: true,
                    sortable: "true",
                    width: 100,
                    render: (h, { row }) => {
                        const value = Number(row.anomaly_score || 0);
                        return h("span", value.toFixed(2) || "-"); // 四捨五入 → 小數點 2 位
                    }
                }
            ],

            // Radio
            selectedRadio: "events",
            radioList: [
                {
                    key: "settings",
                    title: this.$t("behaviorAnalyze.settingsTitle"),
                    description: this.$t("behaviorAnalyze.settingsDescription")
                },
                {
                    key: "events",
                    title: this.$t("behaviorAnalyze.eventsTitle"),
                    description: this.$t("behaviorAnalyze.eventsDescription")
                }
            ],
            searchView: "BehaviorAnalyze",
            behaviorType: "*", // 預設：搜尋全部

            // 表格資料
            data: [],
            tableDataTotal: 0,
            behaviorClassificationStats: {
                db0Count: 0,
                db1Count: 0
            },
            behaviorUserStats: {
                db0UserCount: 0,
                db1UserCount: 0,
                db0IpList: [],
                db1IpList: []
            },

            // 計算「請求總數」以及「使用者總數」的比例
            accessRequestCount: 0,
            accessUniqueUserCount: 0,

            // 分頁設定
            pageSize: 10,
            pageCurrent: 1,

            isLoading: false,
            isUsageLoading: false,

            // 圖表相關
            selectedIp: "",
            ipTrafficChartData: [],
            ipStatusStats: [],
            ipTrafficTotalCount: 0,
            originStats: {},
            totalBytesSent: 0
        };
    },
    computed: {
        // 從 store 取得目前的 groupName，並做 'all' → '*'
        currentGroupName() {
            const q = this.$store.state.queryGroupName;
            if (q === "all") return "*";
            return q;
        },
        // 格式化請求總數（加逗號）
        formattedTotalCount() {
            return this.ipTrafficTotalCount.toLocaleString();
        },
        // 把 Bytes → B / KB / MB / GB
        formattedTotalBytes() {
            const b = Number(this.totalBytesSent || 0);
            if (b < 1024) return b.toFixed(2) + "B";
            if (b < 1024 * 1024) return (b / 1024).toFixed(2) + "KB";
            if (b < 1024 * 1024 * 1024) return (b / 1024 / 1024).toFixed(2) + "MB";
            return (b / 1024 / 1024 / 1024).toFixed(2) + "GB";
        },
        // ---------- Request 百分比 ----------
        db0RequestPercent() {
            return this.toPercent(this.behaviorClassificationStats.db0Count, this.accessRequestCount);
        },
        db1RequestPercent() {
            return this.toPercent(this.behaviorClassificationStats.db1Count, this.accessRequestCount);
        },
        // ---------- User 百分比 ----------
        db0UserPercent() {
            return this.toPercent(this.behaviorUserStats.db0UserCount, this.accessUniqueUserCount);
        },
        db1UserPercent() {
            return this.toPercent(this.behaviorUserStats.db1UserCount, this.accessUniqueUserCount);
        }
    },
    mounted() {
        this.fetchTableData();
        this.fetchUsage();
    },
    methods: {
        filterByKeys(source = {}, keys = []) {
            const result = {};
            keys.forEach(k => {
                if (k in source) {
                    result[k] = source[k];
                }
            });
            return result;
        },
        async fetchDetail(reqId) {
            if (!reqId) return;

            try {
                const options = {
                    isFuzzySearch: false,
                    esIndex: "rcm-monitor-edge-accesslog-*",
                    from: 0,
                    size: 10,
                    sort: [{ timestamp: { order: "desc" } }, { "@timestamp": { order: "desc" } }],
                    filters: [
                        { key: "req_id", type: "string", value: reqId },
                        { key: "group", type: "string", value: this.currentGroupName }
                    ],
                    searchView: "WafEvent"
                };

                return await getEsData(options);
            } catch (e) {
                console.log("FAILED to fetch WAF event detail:", e);
            }
        },
        goToWafEvents({ ip }) {
            this.$router.push({
                name: "WafEvents",
                query: {
                    cus_realy_addr: ip
                }
            });
        },
        toPercent(numerator, denominator) {
            const n = Number(numerator || 0);
            const d = Number(denominator || 0);
            if (!d) return "0%";
            return ((n / d) * 100).toFixed(2) + "%";
        },
        async fetchTableData() {
            this.isLoading = true;
            try {
                const groupName = this.$store.state.queryGroupName;
                const from = (this.pageCurrent - 1) * this.pageSize;
                const { data } = await getBehaviorAnalyzeDataList({
                    groupName,
                    behaviorType: this.behaviorType,
                    from,
                    size: this.pageSize
                });

                if (data.success) {
                    const list = data.mapData || [];
                    this.data = list.map(item => ({
                        ...item,
                        select: typeof item.select === "boolean" ? item.select : false
                    }));

                    this.tableDataTotal = typeof data.total === "number" ? data.total : this.data.length;
                    this.behaviorClassificationStats = data.behaviorClassificationStats;
                    this.behaviorUserStats = data.behaviorUserStats;
                }
            } catch (err) {
                console.log("API 請求失敗:", err);
            } finally {
                this.isLoading = false;
            }
        },
        async fetchUsage() {
            this.isUsageLoading = true;
            try {
                const groupName = this.$store.state.queryGroupName;
                const { data: usageRes } = await getAccessLogUsage({ groupName });

                if (usageRes.success) {
                    this.accessRequestCount = usageRes.accessRequestCount;
                    this.accessUniqueUserCount = usageRes.accessUniqueUserCount;
                }
            } catch (err) {
                console.log("API 請求失敗:", err);
            } finally {
                this.isUsageLoading = false;
            }
        },
        changePage(page) {
            this.pageCurrent = page;
            this.fetchTableData();
        },
        changePageSize(size) {
            this.pageSize = size;
            this.pageCurrent = 1;
            this.fetchTableData();
        },

        handleBehaviorTypeChange(name) {
            this.behaviorType = name; // "" / "db0" / "db1"
            this.pageCurrent = 1;

            // 換篩選時清空所有 IP 資料
            this.resetIpSelection();
            this.fetchTableData();
            this.fetchUsage();
        },
        // 共用：清掉單一 IP 的詳細統計資料
        resetIpTrafficData() {
            this.ipTrafficChartData = [];
            this.ipStatusStats = [];
            this.ipTrafficTotalCount = 0;
            this.originStats = {};
            this.totalBytesSent = 0;
        },
        // 共用：清掉選取 IP 與詳細資料
        resetIpSelection() {
            this.data = this.data.map(row => ({ ...row, select: false }));
            this.selectedIp = "";
            this.resetIpTrafficData();
        },
        async checkboxOnChange(changedRow) {
            // 取消勾選 → 清空所有資料
            if (!changedRow.select) return this.resetIpSelection();

            // 單選
            this.data = this.data.map(row => ({
                ...row,
                select: row.rid === changedRow.rid
            }));

            if (!changedRow.ip || !changedRow["@timestamp"]) {
                console.log("[checkboxOnChange] 缺少 ip 或 @timestamp", changedRow);
                return;
            }

            this.selectedIp = changedRow.ip;
            await this.fetchIpTraffic(changedRow);
        },

        // 從後端取得 IP 統計
        async fetchIpTraffic(row) {
            try {
                const params = {
                    ip: row.ip,
                    baseTimestamp: row["@timestamp"],
                    groupName: this.$store.state.queryGroupName
                };

                const { data } = await getIpTrafficByCusRealAddr(params);

                if (!data || !data.success) return this.resetIpTrafficData();

                // --- 後端回傳數據 ---
                this.ipTrafficChartData = data.chartData || [];
                this.ipStatusStats = data.statusStats || [];
                this.ipTrafficTotalCount = data.totalCount || 0;
                this.originStats = data.originStats || {};
                this.totalBytesSent = data.totalBytesSent || 0;
            } catch (err) {
                return this.resetIpTrafficData();
            }
        }
    }
};
</script>

<style scoped>
.ip-card-col {
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
}

.ip-chart-row {
    margin-top: 16px;
    /* 讓每個 Col 的高度對齊，用 flex 的 stretch 效果 */
    align-items: stretch;
}

.ip-chart-col {
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
}

/* 三個大卡片統一用 flex 撐高，不用固定 px 高度 */
.ip-chart-card {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 12px;
}

.ip-chart-title {
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 600;
}

/* 內容區也用 flex，圖表置中 */
.ip-chart-body {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* 限制圖表大小，避免頂到邊界被吃掉 */
.ip-chart-body canvas {
    max-width: 80%;
    max-height: 80%;
}

.ip-chart-empty {
    text-align: center;
    color: #999;
}

/* 數字卡：改成用 flex 平均分掉整個欄位高度 */
.number-card {
    position: relative;
    flex: 1; /* 兩張各佔一半高度 */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

/* 兩張卡中間留空隙 */
.number-card + .number-card {
    margin-top: 8px;
}

.number-value {
    font-size: 28px;
}

.number-label {
    color: #888;
}

.percent {
    position: absolute;
    right: 10px;
    bottom: 8px;
    color: #888;
    font-size: 14px;
}

.protect-btn {
    position: absolute;
    right: 10px;
    top: 8px;
    color: #888;
    font-size: 14px;
}

.eye-btn {
    position: absolute;
    left: 10px;
    bottom: 8px;
    color: #888;
    font-size: 14px;
}

/* 長條圖卡保持原本設計，但不需要刻意固定高度 */
.ip-traffic-bar-card {
    padding-bottom: 60px;
}

.ip-traffic-bar-body {
    height: 340px;
}
</style>



// WEBPACK FOOTER //
// src/view/dashboard/BehaviorAnalyze.vue